import React, { Component } from "react";
import "./App.css";
import RouterConfig from "./router";
import { BrowserRouter as Router } from "react-router-dom";
import { createBrowserHistory } from "history";
const history = createBrowserHistory();

class App extends Component {
  render() {
    return (
      <Router history={history} basename={'/gzh'}>    
      <div className="App">
        <RouterConfig />
      </div>
      </Router>
    );
  }
}

export default App;
